<div class="row">
  <div class="col-sm-12">
    <section class="panel">
      <app-page-title title="Edit Folder" [loading]="isLoading"></app-page-title>

      <div class="panel-body">
        <form class="form-horizontal" (ngSubmit)="edit()" ngNativeValidate>
          <app-folder-form [folder]="folder" *ngIf="folder"></app-folder-form>
        </form>
      </div>
    </section>
  </div>
</div>
